/* Jollumi theme — small vanilla JS: hero slider, header, cart, product form, FAQ filter. */
(function () {
  'use strict';
  var J = window.Jollumi || { routes: {}, strings: {} };

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    var fmt = format || J.moneyFormat || '{{amount}}';
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function addCommas(num, prec, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(num) || num == null) return '0';
      num = (num / 100).toFixed(prec);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    switch ((fmt.match(placeholder) || [])[1]) {
      case 'amount': value = addCommas(cents, 2); break;
      case 'amount_no_decimals': value = addCommas(cents, 0); break;
      case 'amount_with_comma_separator': value = addCommas(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = addCommas(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = addCommas(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = addCommas(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = addCommas(cents, 2, ' ', ','); break;
      default: value = addCommas(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  var toastTimer;
  function toast(text) {
    var el = $('#CartToast'); if (!el) return;
    $('.cart-toast__text', el).textContent = text;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 3200);
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* ---------- announcement / header ---------- */
  function initHeader() {
    var toggle = $('[data-menu-toggle]');
    var nav = $('[data-mobile-nav]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    var sToggle = $('[data-search-toggle]');
    var sPanel = $('[data-search-panel]');
    if (sToggle && sPanel) {
      sToggle.addEventListener('click', function () {
        sPanel.hidden = !sPanel.hidden;
        sToggle.setAttribute('aria-expanded', sPanel.hidden ? 'false' : 'true');
        if (!sPanel.hidden) { var i = $('input', sPanel); if (i) i.focus(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sPanel.hidden) { sPanel.hidden = true; sToggle.focus(); } });
    }
  }

  /* ---------- hero slideshow ---------- */
  function initHero() {
    $$('[data-hero]').forEach(function (hero) {
      var slides = $$('.hero__slide', hero);
      if (slides.length < 2) { hero.classList.add('hero--single'); return; }
      var dots = $$('.hero__dot', hero);
      var autoplay = hero.getAttribute('data-autoplay') === 'true';
      var interval = parseInt(hero.getAttribute('data-interval'), 10) || 6000;
      var idx = 0, timer;
      function go(n) {
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); s.setAttribute('aria-hidden', i === idx ? 'false' : 'true'); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        restart();
      }
      function restart() {
        clearInterval(timer);
        if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(function () { go(idx + 1); }, interval);
      }
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      var prev = $('[data-hero-prev]', hero), next = $('[data-hero-next]', hero);
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      hero.addEventListener('mouseenter', function () { clearInterval(timer); });
      hero.addEventListener('mouseleave', restart);
      go(0);
    });
  }

  /* ---------- quantity inputs ---------- */
  function initQty(ctx) {
    $$('[data-qty]', ctx).forEach(function (wrap) {
      if (wrap.__qty) return; wrap.__qty = true;
      var input = $('input', wrap);
      var min = parseInt(input.min || '1', 10), max = parseInt(input.max || '0', 10) || Infinity;
      $$('button', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value || '1', 10) + (b.getAttribute('data-dir') === 'down' ? -1 : 1);
          v = Math.max(min, Math.min(max, v));
          if (v !== parseInt(input.value, 10)) { input.value = v; input.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      });
    });
  }

  /* ---------- add to cart (any form[data-ajax-cart]) ---------- */
  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[data-ajax-cart]')) return;
      e.preventDefault();
      var btn = $('[type="submit"]', form);
      var label = btn ? $('[data-label]', btn) || btn : null;
      var original = label ? label.textContent : '';
      if (btn) btn.setAttribute('aria-disabled', 'true');
      var fd = new FormData(form);
      fd.append('sections', 'cart-count');
      fetchJSON(J.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (item) {
          return fetchJSON(J.routes.cart + '.js').then(function (cart) {
            updateCartCount(cart.item_count);
            if (label) label.textContent = J.strings.added || 'Added';
            var notice = form.closest('[data-product-form-wrap]') ? $('[data-added-notice]', form.closest('[data-product-form-wrap]')) : null;
            if (notice) {
              var summary = $('[data-added-summary]', notice);
              if (summary) summary.textContent = (item.quantity || 1) + ' × ' + item.product_title + (item.variant_title ? ' · ' + item.variant_title : '');
              notice.hidden = false;
              clearTimeout(notice.__t); notice.__t = setTimeout(function () { notice.hidden = true; }, 4000);
            } else {
              toast((J.strings.addedToCart || 'Added to cart.') + ' ' + item.product_title);
            }
            setTimeout(function () { if (label) label.textContent = original; }, 1400);
          });
        })
        .catch(function (err) {
          toast((err && (err.description || err.message)) || 'Could not add to cart');
          if (label) label.textContent = original;
        })
        .then(function () { if (btn) btn.removeAttribute('aria-disabled'); });
    });
  }

  /* ---------- product form: variant picker ---------- */
  function initProductForms(ctx) {
    $$('[data-product-form-wrap]', ctx).forEach(function (wrap) {
      if (wrap.__pf) return; wrap.__pf = true;
      var dataEl = $('[data-variants-json]', wrap);
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var idInput = $('input[name="id"]', wrap);
      var btn = $('[data-add-button]', wrap);
      var btnLabel = btn ? $('[data-label]', btn) : null;
      var priceEl = $('[data-price]', wrap);
      var compareEl = $('[data-compare-price]', wrap);
      var optionCount = parseInt(wrap.getAttribute('data-option-count') || '0', 10);
      var mainImg = $('[data-main-media]', wrap);
      var thumbs = $$('[data-thumb]', wrap);

      function selected() {
        var vals = [];
        for (var i = 1; i <= optionCount; i++) {
          var checked = $('input[name="option' + i + '"]:checked', wrap) || $('select[name="option' + i + '"]', wrap);
          vals.push(checked ? checked.value : null);
        }
        return vals;
      }
      function findVariant(vals) {
        return variants.filter(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); })[0];
      }
      function markAvailability(vals) {
        for (var i = 0; i < optionCount; i++) {
          $$('[data-option-index="' + (i + 1) + '"] [data-option-value]', wrap).forEach(function (el) {
            var test = vals.slice(); test[i] = el.getAttribute('data-option-value');
            var v = variants.filter(function (vv) { return vv.options.every(function (o, k) { return k === i ? o === test[i] : (vals[k] == null || o === vals[k]); }); });
            var avail = v.some(function (vv) { return vv.available; });
            el.classList.toggle('is-unavailable', !avail && v.length > 0);
          });
        }
      }
      function update() {
        if (optionCount === 0) { if (btn && variants[0] && variants[0].available) btn.removeAttribute('disabled'); return; }
        var vals = selected();
        var v = findVariant(vals);
        markAvailability(vals);
        $$('[data-option-index]', wrap).forEach(function (grp) {
          var i = parseInt(grp.getAttribute('data-option-index'), 10) - 1;
          var lbl = $('[data-option-selected]', grp); if (lbl) lbl.textContent = vals[i] || '';
          $$('[data-option-value]', grp).forEach(function (el) { el.classList.toggle('is-selected', el.getAttribute('data-option-value') === vals[i]); });
        });
        if (!v) {
          if (btn) { btn.setAttribute('disabled', ''); if (btnLabel) btnLabel.textContent = J.strings.unavailable || 'Unavailable'; }
          return;
        }
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        var bbPrice = $('[data-buy-bar-price]', wrap); if (bbPrice) bbPrice.textContent = formatMoney(v.price);
        var bbBtn = $('[data-buy-bar-button]', wrap); if (bbBtn) { if (v.available) bbBtn.removeAttribute('disabled'); else bbBtn.setAttribute('disabled', ''); }
        var stockEl = $('[data-stock]', wrap);
        if (stockEl) {
          var thr = parseInt(stockEl.getAttribute('data-threshold'), 10) || 5, st = 'in_stock';
          if (!v.available) st = 'sold_out';
          else if (v.inventory_management === 'shopify' && v.inventory_policy === 'deny' && typeof v.inventory_quantity === 'number' && v.inventory_quantity <= thr) st = 'low';
          stockEl.className = 'product__stock product__stock--' + st;
          stockEl.textContent = st === 'sold_out' ? (J.strings.stockSoldOut || 'Sold out') : st === 'low' ? (J.strings.stockLow || 'Only [count] left').replace('[count]', v.inventory_quantity) : (J.strings.stockIn || 'In stock');
        }
        if (compareEl) { if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.hidden = false; } else compareEl.hidden = true; }
        if (btn) {
          if (v.available) { btn.removeAttribute('disabled'); if (btnLabel) btnLabel.textContent = (J.strings.addToCart || 'Add to cart') + ' — ' + formatMoney(v.price); }
          else { btn.setAttribute('disabled', ''); if (btnLabel) btnLabel.textContent = J.strings.soldOut || 'Sold out'; }
        }
        if (v.featured_media && mainImg) {
          var t = thumbs.filter(function (th) { return th.getAttribute('data-media-id') === String(v.featured_media.id); })[0];
          if (t) t.click();
        }
        if (history.replaceState && wrap.getAttribute('data-update-url') === 'true') {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
        }
      }
      wrap.addEventListener('change', function (e) { if (e.target.matches('input[name^="option"], select[name^="option"]')) update(); });
      update();
    });

    /* gallery: thumbs activate the matching media item (image, video, 3D model) */
    $$('[data-main-media]', ctx).forEach(function (main) {
      if (main.__gallery) return; main.__gallery = true;
      var scope = main.closest('[data-product-form-wrap]') || document;
      var items = $$('[data-media-item]', main);
      function showMedia(id) {
        items.forEach(function (it) {
          var active = it.getAttribute('data-media-id') === String(id);
          it.classList.toggle('is-active', active);
          var vid = $('video', it);
          if (vid && !active && !vid.paused) vid.pause();
          if (vid && active && it.getAttribute('data-media-type') === 'video') { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
        });
        $$('[data-thumb]', scope).forEach(function (x) {
          var on = x.getAttribute('data-media-id') === String(id);
          x.classList.toggle('is-active', on);
          if (on && x.scrollIntoView && x.closest('.product__thumbs--scroll')) x.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        });
      }
      $$('[data-thumb]', scope).forEach(function (t) {
        t.addEventListener('click', function () { showMedia(t.getAttribute('data-media-id')); });
      });
    });
  }

  /* ---------- quick view (products with options, opened from cards) ---------- */
  function initQuickView() {
    var root = $('[data-quick-view]'); if (!root) return;
    var panel = $('[data-quick-view-panel]', root), body = $('[data-quick-view-body]', root);
    var lastFocus = null, token = 0;
    function close() {
      if (root.hidden) return;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('quick-view-open');
      setTimeout(function () { root.hidden = true; body.innerHTML = ''; }, 220);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function open(url, trigger) {
      lastFocus = trigger || document.activeElement;
      var u = new URL(url, window.location.href); u.searchParams.set('section_id', 'quick-view');
      var my = ++token;
      body.innerHTML = '<div class="quick-view__loading" aria-busy="true"><span class="quick-view__spinner"></span></div>';
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-open'); document.documentElement.classList.add('quick-view-open'); panel.focus(); });
      fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        if (my !== token || root.hidden) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = $('.quick-view__content', doc);
        if (!content) { window.location.href = url; return; }
        body.innerHTML = '';
        body.appendChild(content);
        initQty(body); initProductForms(body);
        var first = $('.quick-view__close', root); if (first) first.focus();
      }).catch(function () { window.location.href = url; });
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-quick-view-trigger]');
      if (t) { e.preventDefault(); open(t.getAttribute('data-quick-view-trigger') || t.getAttribute('href'), t); return; }
      if (e.target.closest('[data-quick-view-close]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
  }

  /* ---------- cart page ---------- */
  function initCart() {
    var cart = $('[data-cart]');
    if (!cart) return;
    var busy = false;
    function change(line, qty, row) {
      if (busy) return; busy = true;
      if (row) row.classList.add('is-loading');
      var body = { line: line, quantity: qty, sections: cart.getAttribute('data-section-id') };
      fetchJSON(J.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (c) {
          var html = c.sections && c.sections[body.sections];
          if (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = $('[data-cart]', doc);
            if (fresh) { cart.innerHTML = fresh.innerHTML; initQty(cart); }
          }
          updateCartCount(c.item_count);
        })
        .catch(function (err) { toast((err && err.description) || 'Could not update cart'); if (row) row.classList.remove('is-loading'); })
        .then(function () { busy = false; });
    }
    cart.addEventListener('change', function (e) {
      if (!e.target.matches('[data-line-qty]')) return;
      var row = e.target.closest('[data-line]');
      change(parseInt(row.getAttribute('data-line'), 10), parseInt(e.target.value, 10) || 0, row);
    });
    cart.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-line-remove]');
      if (!rm) return;
      e.preventDefault();
      var row = rm.closest('[data-line]');
      change(parseInt(row.getAttribute('data-line'), 10), 0, row);
    });
  }

  /* ---------- FAQ filter (support page; search + items may live in different sections) ---------- */
  function initFaq() {
    var items = $$('[data-faq-item]');
    if (!items.length) return;
    var input = $('[data-faq-search]');
    var count = $('[data-faq-count]');
    var empty = $('[data-faq-empty]');
    var total = items.length;
    var tpl = count ? count.getAttribute('data-template') : '';
    function norm(s) { return (s || '').toLowerCase().replace(/[\u2011-]/g, ''); }
    function run() {
      var q = norm(input ? input.value.trim() : '');
      var shown = 0;
      items.forEach(function (it) {
        var hit = !q || norm(it.textContent).indexOf(q) !== -1;
        it.hidden = !hit; if (hit) shown++;
        if (q && hit) it.open = false;
      });
      if (count && tpl) count.textContent = tpl.replace('[shown]', shown).replace('[total]', total);
      if (empty) { empty.hidden = shown !== 0; var t = $('[data-faq-terms]', empty); if (t) t.textContent = input ? input.value : ''; }
    }
    if (input && !input.__faq) { input.__faq = true; input.addEventListener('input', run); }
    $$('[data-faq-quick]').forEach(function (b) { if (b.__faq) return; b.__faq = true; b.addEventListener('click', function () { if (input) { input.value = b.getAttribute('data-faq-quick'); run(); input.focus(); var f = $('#faq'); if (f) f.scrollIntoView({ behavior: 'smooth' }); } }); });
    run();
  }

  /* ---------- exclusive accordions (one open at a time) ---------- */
  function initAccordions() {
    $$('[data-accordion-exclusive]').forEach(function (acc) {
      acc.addEventListener('toggle', function (e) {
        if (e.target.open) $$('details', acc).forEach(function (d) { if (d !== e.target) d.open = false; });
      }, true);
    });
  }

  /* ---------- collection facets: auto-submit ---------- */
  function initFacets() {
    var form = $('[data-facets-form]');
    if (!form) return;
    var t;
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"], select')) { clearTimeout(t); t = setTimeout(function () { form.requestSubmit ? form.requestSubmit() : form.submit(); }, 150); }
    });
    $$('[data-facets-submit]').forEach(function (sel) { sel.addEventListener('change', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); }); });
    var toggle = $('[data-facets-toggle]');
    var facets = $('[data-facets]');
    if (toggle && facets) toggle.addEventListener('click', function () { facets.hidden = !facets.hidden; toggle.setAttribute('aria-expanded', facets.hidden ? 'false' : 'true'); });
  }


  /* ---------- product recommendations (Section Rendering API) ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (sec) {
      if (sec.__done) return; sec.__done = true;
      var url = sec.getAttribute('data-url'); if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = $('[data-recommendations-grid]', doc);
        if (grid && grid.children.length) { $('[data-recommendations-grid]', sec).innerHTML = grid.innerHTML; initQty(document); initScroll3d(); }
      }).catch(function () {});
    });
  }

  /* ---------- sticky buy bar: show once the main button scrolls away ---------- */
  function initBuyBar() {
    var bar = $('[data-buy-bar]'); var btn = $('[data-add-button]');
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      // Show only after the real button has scrolled above the viewport.
      bar.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      document.documentElement.classList.toggle('buy-bar-visible', !bar.hidden);
    }, { threshold: 0 });
    io.observe(btn);
  }

  /* ---------- long description: collapse with Read more ---------- */
  function initDescription() {
    var body = $('[data-description][data-collapsible]'); var toggle = $('[data-description-toggle]');
    if (!body || !toggle) return;
    var max = parseInt(body.getAttribute('data-collapsible'), 10) || 900;
    body.style.setProperty('--collapsed', max + 'px');
    if (body.scrollHeight > max + 120) {
      body.classList.add('is-collapsed'); toggle.hidden = false;
      toggle.addEventListener('click', function () {
        var open = body.classList.toggle('is-collapsed') === false;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.textContent = open ? 'Show less' : toggle.getAttribute('data-label') || toggle.textContent;
        if (!open) body.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      toggle.setAttribute('data-label', toggle.textContent);
    }
  }

  /* ---------- 3D scroll effect ----------
     Explicit: any [data-scroll-3d] container (data-depth, data-hover-tilt, data-items selector).
     Automatic (theme settings): section grids, panels and product grids. */
  var s3d = { targets: [], bound: false, ticking: false };
  function initScroll3d() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var cfg = (window.Jollumi && window.Jollumi.scroll3d) || {};
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
    var ease = function (t) { return 1 - Math.pow(1 - t, 3); };
    var children = function (el, sel) { return Array.prototype.filter.call(el.children, function (n) { return n.nodeType === 1 && (!sel || n.matches(sel)); }); };

    function register(stage, items, opts) {
      if (!stage || !items.length) return;
      var t = stage.__s3d;
      if (!t) { t = { stage: stage, items: [], depth: opts.depth, hover: opts.hover, shadow: opts.shadow, fade: opts.fade }; stage.__s3d = t; s3d.targets.push(t); stage.classList.add('s3d-stage'); }
      items.forEach(function (item) {
        if (item.classList.contains('s3d-item')) return;
        item.classList.add('s3d-item');
        t.items.push(item);
        if (t.hover && finePointer) bindHover(item, t);
      });
    }

    function bindHover(card, t) {
      card.addEventListener('mousemove', function (ev) {
        var r = card.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        card.classList.add('is-hovering'); card.classList.remove('is-settling');
        card.style.setProperty('--rx', (y * -10 * t.depth).toFixed(2) + 'deg');
        card.style.setProperty('--ry', (x * 12 * t.depth).toFixed(2) + 'deg');
        card.style.setProperty('--ty', (-6 * t.depth).toFixed(1) + 'px');
        card.style.setProperty('--tz', (18 * t.depth).toFixed(1) + 'px');
        card.style.setProperty('--op', '1');
        card.style.setProperty('--shadow', t.shadow ? '1' : '0');
        card.style.setProperty('--mz', (24 * t.depth).toFixed(1));
      });
      card.addEventListener('mouseleave', function () {
        card.classList.remove('is-hovering'); card.classList.add('is-settling');
        card.style.setProperty('--mz', '0');
        request();
        setTimeout(function () { card.classList.remove('is-settling'); }, 520);
      });
    }

    function columnsOf(items) {
      var first = items[0].getBoundingClientRect(), count = 1;
      for (var i = 1; i < items.length; i++) { if (Math.abs(items[i].getBoundingClientRect().top - first.top) < 2) count++; else break; }
      return count;
    }

    function update() {
      s3d.ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var small = window.innerWidth < 760;
      s3d.targets.forEach(function (t) {
        t.items = t.items.filter(function (i) { return i.isConnected; });
        if (!t.items.length) return;
        var cols = columnsOf(t.items);
        var scale = (small ? 0.55 : 1) * t.depth;
        t.items.forEach(function (card, i) {
          if (card.classList.contains('is-hovering')) return;
          var r = card.getBoundingClientRect();
          if (r.bottom < -vh || r.top > vh * 2) return;
          /* 0 when the item's top reaches the bottom of the viewport, 1 once it has travelled ~55% of a screen */
          var raw = (vh - r.top) / (vh * 0.55);
          var stagger = (i % cols) * 0.12;
          var e = ease(clamp((raw - stagger) / (1 - stagger), 0, 1));
          /* -0.5 above the middle of the screen, +0.5 below: keeps a gentle tilt while scrolling */
          var c = clamp(((r.top + r.height / 2) - vh / 2) / vh, -0.6, 0.6);
          var rx = (1 - e) * 26 * scale + c * -7 * scale * e;
          var ty = (1 - e) * 70 * scale;
          var tz = (1 - e) * -220 * scale;
          var op = t.fade ? (0.15 + 0.85 * e) : (0.5 + 0.5 * e);
          var shadow = t.shadow ? clamp((1 - Math.abs(c) * 1.4) * e, 0, 1) : 0;
          card.style.setProperty('--rx', rx.toFixed(2) + 'deg');
          card.style.setProperty('--ry', '0deg');
          card.style.setProperty('--ty', ty.toFixed(1) + 'px');
          card.style.setProperty('--tz', tz.toFixed(1) + 'px');
          card.style.setProperty('--op', op.toFixed(3));
          card.style.setProperty('--shadow', shadow.toFixed(3));
        });
      });
    }
    function request() { if (!s3d.ticking) { s3d.ticking = true; window.requestAnimationFrame(update); } }

    /* Explicit containers (e.g. Category grid with its own section settings) */
    $$('[data-scroll-3d]').forEach(function (el) {
      var depth = clamp(parseInt(el.getAttribute('data-depth'), 10) || 60, 0, 100) / 100;
      register(el, children(el, el.getAttribute('data-items')), { depth: depth, hover: el.getAttribute('data-hover-tilt') === 'true', shadow: true, fade: true });
    });

    /* Section grids */
    if (cfg.sections !== false) {
      var depth = clamp(parseInt(cfg.depth, 10) || 60, 0, 100) / 100;
      var hover = cfg.hover !== false;
      ['.review-grid', '.social-grid', '.reels', '.highlight-grid', '.team-grid', '.value-grid', '.topic-grid', '.article-grid', '.collection-list'].forEach(function (sel) {
        $$(sel).forEach(function (el) { if (!el.hasAttribute('data-scroll-3d')) register(el, children(el), { depth: depth, hover: hover, shadow: true, fade: true }); });
      });
      /* Single panels: the parent becomes the perspective stage, the panel is the item */
      ['.promo', '.panel', '.newsletter', '.cta-band'].forEach(function (sel) {
        $$(sel).forEach(function (el) { if (el.parentElement && !el.closest('.s3d-item')) register(el.parentElement, [el], { depth: depth * 0.6, hover: false, shadow: false, fade: false }); });
      });
    }

    /* Product cards: lighter */
    if (cfg.cards !== false) {
      var cardDepth = clamp(parseInt(cfg.cardDepth, 10) || 25, 0, 100) / 100;
      $$('.product-grid').forEach(function (el) { register(el, children(el), { depth: cardDepth, hover: cfg.cardHover === true, shadow: false, fade: false }); });
    }

    if (!s3d.bound) {
      s3d.bound = true;
      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request);
      window.addEventListener('load', request);
    }
    update();
  }

  /* ---------- featured in videos (reels) ---------- */
  function initReels() {
    $$('[data-reels]').forEach(function (track) {
      if (track.__reels) return;
      track.__reels = true;
      var autoplay = track.getAttribute('data-autoplay') === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var reels = $$('[data-reel]', track);
      var sec = track.closest('[data-reels-section]') || document;
      function video(reel) { return $('video', reel); }
      function play(reel) { var v = video(reel); if (!v) return; var p = v.play(); if (p && p.catch) p.catch(function () {}); reel.classList.add('is-playing'); var b = $('[data-reel-play]', reel); if (b) { b.setAttribute('aria-pressed', 'true'); b.setAttribute('aria-label', J.strings.pauseVideo || 'Pause video'); } }
      function pause(reel) { var v = video(reel); if (!v) return; v.pause(); reel.classList.remove('is-playing'); var b = $('[data-reel-play]', reel); if (b) { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', J.strings.playVideo || 'Play video'); } }
      function setMuted(reel, muted) { var v = video(reel); if (!v) return; v.muted = muted; reel.classList.toggle('is-unmuted', !muted); var b = $('[data-reel-mute]', reel); if (b) { b.setAttribute('aria-pressed', muted ? 'true' : 'false'); b.setAttribute('aria-label', muted ? (J.strings.unmuteVideo || 'Unmute') : (J.strings.muteVideo || 'Mute')); } }
      reels.forEach(function (reel) {
        var v = video(reel); if (!v) return;
        v.muted = true; v.setAttribute('muted', ''); v.loop = true;
        reel.__paused = false;
        var playBtn = $('[data-reel-play]', reel), muteBtn = $('[data-reel-mute]', reel), tap = $('[data-reel-tap]', reel);
        function toggle() { if (v.paused) { reel.__paused = false; play(reel); } else { reel.__paused = true; pause(reel); } }
        if (playBtn) playBtn.addEventListener('click', toggle);
        if (tap) tap.addEventListener('click', toggle);
        if (muteBtn) muteBtn.addEventListener('click', function () {
          var unmute = v.muted;
          reels.forEach(function (o) { if (o !== reel) setMuted(o, true); });
          setMuted(reel, !unmute);
          if (unmute && v.paused) { reel.__paused = false; play(reel); }
        });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var reel = en.target;
            if (en.isIntersecting && en.intersectionRatio >= 0.5) { if (autoplay && !reel.__paused) play(reel); }
            else { var v = video(reel); if (v && !v.paused) { v.pause(); reel.classList.remove('is-playing'); } }
          });
        }, { threshold: [0, 0.5, 1] });
        reels.forEach(function (r) { if (video(r)) io.observe(r); });
      } else if (autoplay) { reels.forEach(play); }
      var prev = $('[data-reels-prev]', sec), next = $('[data-reels-next]', sec);
      function step() { var first = $('.reel', track); return first ? first.getBoundingClientRect().width + 20 : 300; }
      function updateArrows() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  }

  /* ---------- newsletter success scroll ---------- */
  function initNewsletter() {
    if (window.location.hash === '#WelcomeForm') return;
    if (window.location.hash === '#newsletter' || window.location.hash === '#NewsletterForm' || window.location.search.indexOf('customer_posted=true') !== -1) {
      var n = $('#newsletter'); if (n) n.scrollIntoView();
    }
  }

  /* ---------- copy discount code buttons ---------- */
  function initCopyCode() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-copy-code]'); if (!b) return;
      var code = b.getAttribute('data-copy-code'), label = $('[data-label]', b) || b, original = label.textContent;
      function done() { label.textContent = J.strings.copied || 'Copied!'; b.classList.add('is-copied'); setTimeout(function () { label.textContent = original; b.classList.remove('is-copied'); }, 1800); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, function () { fallback(); });
      else fallback();
      function fallback() {
        var t = document.createElement('textarea'); t.value = code; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
        document.body.appendChild(t); t.select(); try { document.execCommand('copy'); done(); } catch (err) {} document.body.removeChild(t);
      }
    });
  }

  /* ---------- welcome popup (10% off signup) ---------- */
  function initWelcome() {
    var root = $('[data-welcome]'); if (!root || root.__welcome) return; root.__welcome = true;
    var KEY = 'jollumi_welcome', TKEY = 'jollumi_welcome_tab', panel = $('.welcome__panel', root), timer;
    var teaser = $('[data-welcome-teaser]');
    function store(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
    function read() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
    function blockedPage() { return /^\/(cart|account|checkout|challenge|password)/.test(window.location.pathname); }
    function showTeaser() {
      if (!teaser || read() === 'subscribed' || blockedPage()) return;
      try { if (sessionStorage.getItem(TKEY)) return; } catch (e) {}
      teaser.hidden = false; requestAnimationFrame(function () { teaser.classList.add('is-visible'); });
    }
    function hideTeaser() { if (teaser) { teaser.classList.remove('is-visible'); teaser.hidden = true; } }
    if (teaser) {
      teaser.addEventListener('click', function (e) {
        if (e.target.closest('[data-welcome-teaser-close]')) { hideTeaser(); try { sessionStorage.setItem(TKEY, '1'); } catch (err) {} return; }
        if (e.target.closest('[data-welcome-open]')) open(true);
      });
    }
    function open(focusInput) {
      if (!root.hidden) return;
      clearTimeout(timer); hideTeaser();
      root.hidden = false;
      requestAnimationFrame(function () {
        root.classList.add('is-open'); document.documentElement.classList.add('welcome-open');
        var f = focusInput && $('#WelcomeEmail', root); (f || panel).focus({ preventScroll: true });
      });
    }
    function close(remember) {
      if (root.hidden) return;
      root.classList.remove('is-open'); document.documentElement.classList.remove('welcome-open');
      setTimeout(function () { root.hidden = true; }, 220);
      if (remember && read() !== 'subscribed') store(String(Date.now()));
      if (read() !== 'subscribed') setTimeout(showTeaser, 260);
    }
    root.addEventListener('click', function (e) { if (e.target.closest('[data-welcome-close]')) close(true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(true); });

    var fromPopup = window.location.hash === '#WelcomeForm';
    if ($('[data-newsletter-success]') || $('[data-welcome-success]', root)) store('subscribed');
    if (fromPopup && ($('[data-welcome-success]', root) || $('[data-welcome-error]', root))) { open(!!$('[data-welcome-error]', root)); return; }

    if (window.Shopify && window.Shopify.designMode) {
      var id = root.getAttribute('data-section-id');
      document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === id) open(false); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === id) close(false); });
      return;
    }
    var state = read();
    if (state === 'subscribed') return;
    var days = parseInt(root.getAttribute('data-days'), 10) || 14;
    if (state && Date.now() - parseInt(state, 10) < days * 864e5) { showTeaser(); return; }
    if (root.getAttribute('data-mobile') === 'false' && window.matchMedia('(max-width: 759px)').matches) { if (state) showTeaser(); return; }
    if (blockedPage()) return;
    function show() {
      if (document.documentElement.classList.contains('quick-view-open')) { timer = setTimeout(show, 4000); return; }
      open(true);
    }
    timer = setTimeout(show, (parseInt(root.getAttribute('data-delay'), 10) || 0) * 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader(); initHero(); initQty(document); initAddToCart(); initProductForms(document); initQuickView(); initCart(); initFaq(); initAccordions(); initFacets(); initRecommendations(); initBuyBar(); initDescription(); initScroll3d(); initReels(); initNewsletter(); initCopyCode(); initWelcome();
  });

  /* Theme editor: re-init sections on load */
  document.addEventListener('shopify:section:load', function () { initHero(); initQty(document); initProductForms(document); initFaq(); initAccordions(); initFacets(); initScroll3d(); initReels(); initWelcome(); });
})();
